import type { ReactNode } from 'react';

/**
 * Consistent page title block used at the top of every admin page.
 *   - title:       page name (h2)
 *   - description: optional one-line subtitle
 *   - actions:     optional right-aligned controls (buttons, refresh, etc.)
 */
export function PageHeader({
  title,
  description,
  actions,
}: {
  title: string;
  description?: string;
  actions?: ReactNode;
}) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-3">
      <div>
        <h2 className="text-xl font-semibold tracking-tight">{title}</h2>
        {description && <p className="mt-1 text-sm text-muted-foreground">{description}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
